import React from 'react';
import { MousePointerClickIcon, LinkIcon, TagIcon } from 'lucide-react';
export function WhySection() {
  const benefits = [{
    icon: <MousePointerClickIcon className="h-6 w-6 text-[#5e60ce]" data-id="element-810" />,
    title: 'Promote Any Amazon Product',
    description: 'Visually appealing and conversion optimized product boxes for any Amazon product right in your newsletter.'
  }, {
    icon: <LinkIcon className="h-6 w-6 text-[#5e60ce]" data-id="element-811" />,
    title: 'Automated Affiliate Linking',
    description: 'Your affiliate ID is automatically added to every product link. No more wasting time creating and managing affiliate links!'
  }, {
    icon: <TagIcon className="h-6 w-6 text-[#5e60ce]" data-id="element-812" />,
    title: 'Real-Time Product Information',
    description: 'All product information, prices, and discounts are up-to-date.'
  }];
  return <section id="why" className="py-20 bg-gray-50" data-id="element-813">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-814">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-815">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-816">
            Why Newsfiliate for Kit?
          </h2>
          <p className="text-xl text-gray-600" data-id="element-817">
            Save hours every week while boosting your affiliate revenue with
            perfectly formatted Amazon deals.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12" data-id="element-818">
          {benefits.map((benefit, index) => <div key={index} className="bg-white rounded-xl p-8 shadow-md hover:shadow-lg transition-shadow text-center" data-id="element-819">
              <div className="flex flex-col items-center" data-id="element-820">
                <div className="mb-5 p-3 rounded-full" style={{
              backgroundColor: '#f2f1f8'
            }} data-id="element-821">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-822">
                  {benefit.title}
                </h3>
                <p className="text-gray-600" data-id="element-823">{benefit.description}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}